import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {PlaceApiModel} from '../../api/models/place.api-model';
import {PlaceCategoryApiModel} from '../../api/models/place-category.api-model';

@Injectable({providedIn: 'root'})
export class PlaceLabelService {
  constructor(private readonly translate: TranslateService) {}

  public category(category?: PlaceCategoryApiModel): string {
    if (!category) {
      return '';
    }
    const key = `places.categories.${category.slug}`;
    const translated = this.translate.instant(key);
    return translated === key ? category.name : translated;
  }

  public name(place?: PlaceApiModel): string {
    if (!place) {
      return '';
    }
    const translations = place.nameTranslations || {};
    const locale = this.translate.currentLang || this.translate.getDefaultLang();
    return translations[locale] || translations['en-US'] || place.name;
  }
}
